import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@scentregroup/ui'
import { Link } from 'react-router-dom'
const FilterItem = ({
  id,
  centre,
  entry,
  onClick,
  className,
  navigatable,
  isSelected,
}) => (
  <Fragment>
    {navigatable ? (
      <Link
        className={className}
        key={entry.slug()}
        to={`/${centre.slug}/whats-happening?range=${entry.slug()}`}
        onClick={onClick}
      >
        {entry.name}
      </Link>
    ) : (
      <Button
        key={entry.slug()}
        id={id}
        className={className}
        ariaPressed={isSelected}
        onClick={onClick}
      >
        {entry.name}
      </Button>
    )}
  </Fragment>
)

FilterItem.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  entry: PropTypes.object,
  centre: PropTypes.object,
  onClick: PropTypes.func,
  navigatable: PropTypes.bool,
  isSelected: PropTypes.bool,
}

FilterItem.defaultProps = {
  navigatable: false,
}

export default FilterItem
